module.exports = __webpack_public_path__ + "static/img/logo@2x (1).7f3693a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mobile/logo@2x (1).png
// module id = cfFD
// module chunks = 1